let runtimeConfig = null;

export function setConfig(cfg) {
  runtimeConfig = cfg;
}

export function getConfig() {
  return runtimeConfig;
}
